import React, { FunctionComponent, useCallback, useMemo } from 'react'

import {
  COLOR_SCHEMES,
  formatChartCurrency,
} from '../../utils/buybackPayoutHelpersNew'

interface LegendItem {
  key: string
  label: string
  value: number
  color: string
}

export interface BuybackFormPayoutChartLegendProps {
  debtAmountTotal: number
  debtFeeTotal: number
  processCostTotal: number
  commission: number
  payout: number
  offerPrice: number
  status: 'red' | 'orange' | 'green'
}

export const BuybackFormPayoutChartLegend: FunctionComponent<BuybackFormPayoutChartLegendProps> =
  ({
    debtAmountTotal,
    debtFeeTotal,
    processCostTotal,
    commission,
    payout,
    offerPrice,
    status,
  }) => {
    const colors = COLOR_SCHEMES[status]

    const labelValue = useCallback(
      (value: number) => {
        const number = typeof value === 'number' ? value : 0
        const percentage = ((number / offerPrice) * 100).toFixed(1)

        return (
          <div className="text-gray-500">
            {formatChartCurrency(number)} ({percentage}%)
          </div>
        )
      },
      [offerPrice]
    )

    const items: LegendItem[] = useMemo(
      () => [
        {
          key: 'debtAmount',
          label: 'Závazky',
          value: debtAmountTotal,
          color: debtAmountTotal > 0 ? colors.debtAmount : '#efefef',
        },
        {
          key: 'debtFee',
          label: 'Odměna závazky',
          value: debtFeeTotal,
          color: debtFeeTotal > 0 ? colors.debtFee : '#efefef',
        },
        {
          key: 'processCost',
          label: 'Adm. poplatky',
          value: processCostTotal,
          color: processCostTotal > 0 ? colors.processCost : '#efefef',
        },
        {
          key: 'commission',
          label: 'Odměna zprostředk.',
          value: commission,
          color: commission > 0 ? colors.commission : '#efefef',
        },
        {
          key: 'payout',
          label: 'K vyplacení',
          value: payout,
          color: payout > 0 ? colors.payout : '#efefef',
        },
      ],
      [
        debtAmountTotal,
        debtFeeTotal,
        processCostTotal,
        commission,
        payout,
        colors,
      ]
    )

    return (
      <div className="grid grid-cols-5 gap-4 mt-4">
        {items.map(item => (
          <div key={item.key} className="flex items-center gap-2">
            <div
              className="w-4 h-4 rounded"
              style={{ backgroundColor: item.color }}
            />
            <div className="text-sm">
              <div className="font-semibold">{item.label}</div>
              {labelValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    )
  }
